import apiClient from '../../../common/functions/api_axios_instance.function';
import { notify } from '../../../common/functions/react-toastify.function';

export const updateTeam = async (data) => {
  try {
    const { id, ...teamData } = data;
    const response = await apiClient.put(`/teamManagement/${id}`, teamData);
    return { success: true, data: response.data };
  } catch (error) {
    console.log(error);
    const errorMessage = error.response?.data?.error || 'Failed to update team';
    notify('error', errorMessage);
    return { success: false, error: errorMessage };
  }
};
